import React from "react";
import { Route, Routes } from "react-router";
import { useSelector } from "react-redux";
import { RootState } from "@reducers/rootReducer";
import { useAuthorization } from "@common/providers";
import { useGetProjectByIdQuery } from "@generated";
import usePrivilegeCheck from "@common/hooks/usePrivilegeCheck";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import Show from "./Show/Show";
import Edit from "./Edit/Edit";
import New from "./New/New";

interface Props {
  project_id: string;
}

const NotesV2Mspa: React.FC<Props> = ({ project_id }) => {
  const projectId = project_id;
  const { accountSlug } = useSelector((state: RootState) => state.slug);

  const { data: project, isLoading: projectLoading } = useGetProjectByIdQuery({
    id: projectId as any,
    slug: accountSlug,
  });

  const { accessLevel, privilegesLoading, user } = usePrivilegeCheck();

  const authorized = useAuthorization();

  if (
    !authorized ||
    projectLoading ||
    privilegesLoading ||
    !project ||
    !user
  ) {
    return <ScopeStackSpinner />;
  }

  const projectStatus = project?.data?.attributes?.status || "";
  const permission = accessLevel("projects.notes") || "view";

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Show
            projectId={projectId}
            projectStatus={projectStatus}
            permission={permission}
          />
        }
      />
      <Route
        path="/edit/:noteId"
        element={
          <Edit
            projectId={projectId}
            permission={permission}
            projectStatus={projectStatus}
          />
        }
      />
      <Route
        path="/new"
        element={
          <New
            projectId={projectId}
            permission={permission}
            projectStatus={projectStatus}
          />
        }
      />
    </Routes>
  );
};

export default NotesV2Mspa;
